<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row" v-if="userData.permissions['interest_payouts'] == 1">
      <div class="col-12">
        <div class="card">
          <div class="card-body">

            <div class="row mb-3">
              <div class="col-md-4">
                <div class="media p-3 shadow-lg">
                  <div class="media-body">
                    <p class="text-muted fw-medium mb-2">Total Interests</p>
                    <h4 class="mb-0">{{ commas(interest) }} </h4>
                  </div>
                  <div class="avatar-sm align-self-center mini-stat-icon rounded-circle bg-primary">
                    <span class="avatar-title"><i class="mdi mdi-cash font-size-24"></i></span>
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="media p-3 shadow-lg">
                  <div class="media-body">
                    <p class="text-muted fw-medium mb-2">Total Payouts</p>
                    <h4 class="mb-0">{{ commas(totalpayouts) }} </h4>
                  </div>
                  <div class="avatar-sm align-self-center mini-stat-icon rounded-circle bg-primary">
                    <span class="avatar-title"><i class="mdi mdi-cash-plus font-size-24"></i></span>
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="media p-3 shadow-lg">
                  <div class="media-body">
                    <p class="text-muted fw-medium mb-2">Balance</p>
                    <h4 class="mb-0">{{ commas(Number(interest) - Number(totalpayouts)) }} </h4>
                  </div>
                  <div class="avatar-sm align-self-center mini-stat-icon rounded-circle bg-primary">
                    <span class="avatar-title"><i class="mdi mdi-cash-check font-size-24"></i></span>
                  </div>
                </div>
              </div>
            </div>

            <span class="d-flex justify-content-between mb-2">
              <div class="d-flex justify-content-between">
                <div><label>From</label><input class="form-control" v-model="date_from" type="date"></div>
                <div class="mx-1"><label>To</label><input class="form-control" v-model="date_to" type="date"></div>
                <div class="mt-4"><b-button variant="primary" @click="FilterData"><i class="mdi mdi-filter"></i>
                    Filter</b-button></div>
              </div>
              <span class="mt-3"><b-button v-show="userData.permissions['interest_payouts'] == 1" v-b-modal.new-payout
                  size="sm" variant="primary"><i class="mdi mdi-plus"></i> New Payout</b-button></span>
            </span>
            <div class="clearfix"></div>
            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show <b-form-select class="form-select form-select-sm mx-1" v-model="perPage" size="sm"
                      :options="Options"></b-form-select> entries
                  </label>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search: <b-form-input v-model="filter" type="search" placeholder="Search..."
                      class="form-control form-control-sm ms-2"></b-form-input>
                  </label>
                </div>
              </div>
            </div>
            <div class="table-responsive">
              <b-table :items="Items" :fields="Fields" responsive="sm" :per-page="perPage" :current-page="currentPage"
                :filter="filter" :filter-included-fields="filterOn" @filtered="Filtered" :busy="IsBusy">
                <template #table-busy>
                  <div class="text-center text-primary my-2"><b-spinner class="align-middle" type="grow"
                      small></b-spinner> <strong>No Data Found</strong></div>
                </template>
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(amount)="data">
                  {{ commas(data.item.amount) }}
                </template>
                <template #cell(addedby)="data">
                  {{ data.item.addedby.username }}
                </template>
                <template #cell(mode_of_payment)="data">
                  {{ data.item.mode_of_payment.name }} <br>
                  <small>{{ data.item.reference }}</small>
                </template>
                <template #cell(member)="data">
                  <b>{{ data.item.member.name }}</b><br>
                  <b class="text-info">{{ data.item.member.member_id }}</b>
                </template>
                <template #cell(actions)="data">
                  <div class="btn-group">
                    <b-button :disabled="data.item.status == 2"
                      @click="edit(data.item.id, data.item.member.member_id, data.item.amount, data.item.mode_of_payment.id, data.item.reference, data.item.date_of_payment)"
                      type="button" class="btn-sm btn" variant="info" v-b-modal.edit> <i
                        class="mdi mdi-square-edit-outline"></i> </b-button>
                    <b-button :disabled="data.item.status == 2" @click="remove(data.item.id, data.item.member.name)"
                      type="button" class="btn-sm btn" variant="danger" v-b-modal.delete> <i
                        class="mdi mdi-trash-can"></i> </b-button>
                  </div>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <b>Total Payouts : {{ commas(totalpayouts) }}</b>
              </div>
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="currentPage" :total-rows="List" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <img src="@/assets/images/profile-img.png" alt class="img-fluid" /><br><br>
            <center><span class="text-primary h6">You have no permission to view Investments</span></center>
          </div>
        </div>
      </div>
    </div>

    <b-modal id="new-payout" centered title="New Payouts" title-class="font-18" hide-footer>
      <form @submit.prevent="addPayout">
        <div class="form-group mb-2">
          <label>Member</label> <small class="text-danger">*</small>
          <v-select :options="members" placeholder="Select an Option" v-model="member" label="name"
            :reduce="member => member.member_id"></v-select>
        </div>
        <div class="form-group mb-2">
          <label>Member ID</label>
          <input v-model="member" type="text" readonly class="form-control" />
        </div>
        <div class="form-group mb-2">
          <label>Transaction Amount</label>
          <input v-model="amount" type="number" class="form-control" />
        </div>
        <div class="form-group mb-2">
          <label>Mode of Payment</label> <small class="text-danger">*</small>
          <v-select :options="paymentoptions" placeholder="Select an Option" v-model="mode_of_payment" label="name"
            :reduce="mode_of_payment => mode_of_payment.id"></v-select>
        </div>
        <div class="form-group mb-2">
          <label>Reference</label>
          <textarea v-model="reference" rows="2" class="form-control"></textarea>
        </div>
        <div class="form-group mb-2">
          <label>Date of Payment</label>
          <input v-model="date_of_payment" :max="currentdate" type="date" class="form-control" />
        </div>
        <div class="form-group d-flex justify-content-end">
          <b-button type="button" class="btn w-30" variant="secondary"
            @click="$bvModal.hide('new-payout')">Close</b-button>
          <b-button type="submit" :disabled="saveBtn" class="btn ms-1 w-30" variant="primary"><i
              class="fas fa-check-circle"></i> Submit</b-button>
        </div>
      </form>
    </b-modal>

    <b-modal id="edit-payout" centered title="Edit Payout" title-class="font-14" hide-footer>
      <form @submit.prevent="editPayout">
        <div class="form-group mb-2">
          <label>Member</label> <small class="text-danger">*</small>
          <v-select :options="members" placeholder="Select an Option" v-model="member" label="name"
            :reduce="member => member.member_id"></v-select>
        </div>
        <div class="form-group mb-2">
          <label>Member ID</label>
          <input v-model="member" type="text" readonly class="form-control" />
        </div>
        <div class="form-group mb-2">
          <label>Transaction Amount</label>
          <input v-model="amount" type="number" class="form-control" />
        </div>
        <div class="form-group mb-2">
          <label>Mode of Payment</label> <small class="text-danger">*</small>
          <v-select :options="paymentoptions" placeholder="Select an Option" v-model="mode_of_payment" label="name"
            :reduce="mode_of_payment => mode_of_payment.id"></v-select>
        </div>
        <div class="form-group mb-2">
          <label>Reference</label>
          <textarea v-model="reference" rows="2" class="form-control"></textarea>
        </div>
        <div class="form-group mb-2">
          <label>Date of Payment</label>
          <input v-model="date_of_payment" :max="currentdate" type="date" class="form-control" />
        </div>
        <div class="form-group d-flex justify-content-end">
          <b-button type="button" class="btn w-30" variant="secondary"
            @click="$bvModal.hide('edit-payout')">Close</b-button>
          <b-button type="submit" class="btn ms-1 w-30" variant="primary"><i class="fas fa-check-circle"></i>
            Submit</b-button>
        </div>
      </form>
    </b-modal>

    <b-modal id="approve-payout" centered title="Are you sure you want to Approve Payout" title-class="font-14"
      hide-footer>
      <form @submit.prevent="approvePayout">
        <div class="form-group mb-2">
          <label>Member : </label>
          <h5><span class="text-info h5" v-html="member"></span> - <span class="text-info h5"
              v-html="membername"></span>
          </h5>
        </div>
        <div class="form-group mb-2">
          <label>Transaction Amount</label>
          <h5 class="text-info" v-html="commas(amount)"></h5>
        </div>
        <div class="form-group mb-2">
          <label>Mode of Payment</label>
          <h5 class="text-info" v-html="mode_of_payment"></h5>
        </div>
        <div class="form-group mb-2">
          <label>Reference</label>
          <h5 class="text-info" v-html="reference"></h5>
        </div>
        <div class="form-group mb-2">
          <label>Date of Payment</label>
          <h5 class="text-info" v-html="date_of_payment"></h5>
        </div>
        <div class="form-group d-flex justify-content-end">
          <b-button type="button" class="btn w-30" variant="secondary"
            @click="$bvModal.hide('approve-payout')">Close</b-button>
          <b-button type="submit" class="btn ms-1 w-30" variant="primary"><i class="fas fa-check-circle"></i>
            Submit</b-button>
        </div>
      </form>
    </b-modal>

    <b-modal id="delete-payout" centered title="Delete Payout" title-class="font-18" hide-footer>
      <form @submit.prevent="removePayout">
        <input v-model="id" type="hidden">
        Are you sure you want to delete the Payout for : <b>{{ membername }}</b> ?
        <div class="form-group d-flex justify-content-end">
          <b-button type="button" class="btn w-30" variant="secondary"
            @click="$bvModal.hide('delete-payout')">Close</b-button>
          <b-button type="submit" class="btn ms-1 w-30" variant="primary"><i class="fas fa-check-circle"></i>
            YES</b-button>
        </div>
      </form>
    </b-modal>

  </Layout>
</template>

<script>
import axios from "axios";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import {
  interestpayoutMethods, interestpayoutComputed,
  memberMethods, memberComputed,
  paymentoptionMethods, paymentoptionComputed
} from "@/state/helpers";

export default {
  page: {
    title: "Interest Payouts",
    meta: [{ name: "description", content: appConfig.description, },],
  },
  components: {
    Layout, PageHeader
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      title: "Interest Payouts",
      items: [{ text: "Dashboard", to: "/", }, { text: "Interest Payouts", active: true, },],
      TotalRows: 1,
      currentPage: 1,
      perPage: 10,
      Options: [10, 50, 100, 150, 200],
      filter: null,
      todoFilter: null,
      filterOn: [],
      sortDesc: true,
      isBusy: true,
      fields: [
        { key: 'index', label: '#', visible: true },
        { key: 'id', label: 'ID', visible: false },
        { key: 'member', label: 'Member', visible: true },
        { key: 'amount', label: 'Amount', visible: true },
        { key: 'mode_of_payment', label: 'Mode Of Payment', visible: true },
        { key: 'date_of_payment', label: 'Date Of Payment', visible: true },
        { key: 'addedby', label: 'Added by', visible: true },
        { key: 'actions', label: 'Actions', visible: true },
      ],
      id: '',
      member: '',
      amount: '',
      mode_of_payment: '',
      reference: '',
      date_of_payment: new Date().toLocaleDateString('fr-CA'),
      membername: '',
      saveBtn: false,
      saveError: '',
      currentdate: new Date().toLocaleDateString('fr-CA'),
      date_to: new Date().toLocaleDateString('fr-CA'),
      date_from: new Date().toLocaleDateString('fr-CA'),
      interest: 0,
    };
  },
  computed: {
    ...interestpayoutComputed,
    ...memberComputed,
    ...paymentoptionComputed,
    List() { return this.interestpayouts.length; },
    Fields() { return this.fields.filter(field => field.visible) },
    Items() { return this.interestpayouts.map((d) => ({ ...d })) },
    IsBusy() { let a = false; if (this.interestpayouts.length > 0) { a = false; } else { a = true; } return a },
    totalpayouts() { var total = 0; this.interestpayouts.forEach((item) => { var item_total = item.amount; total = Number(total) + Number(item_total); }); return total },
  },
  mounted() {
    this.fetchInterestPayouts();
    this.fetchMembers();
    this.fetchPaymentoptions();
    this.dashboardanalysis();
    this.TotalRows = this.interestpayouts.length;
    this.isBusy = false;
  },
  methods: {
    ...interestpayoutMethods,
    ...memberMethods,
    ...paymentoptionMethods,
    Filtered(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },
    commas(x) { return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); },
    async dashboardanalysis() {
      let url = `/dashboardanalysis`;
      await axios.post(url).then((response) => {
        this.interest = response.data.interest;
      });
    },
    async addPayout() {
      this.saveBtn = true;
      this.saveError = "Saving Member Payouts";
      let formData = new FormData();
      formData.append("member", this.member);
      formData.append("amount", this.amount);
      formData.append("mode_of_payment", this.mode_of_payment);
      formData.append("reference", this.reference);
      formData.append("date_of_payment", this.date_of_payment);
      let url = "/addinterestpayout";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchInterestPayouts();
          this.$bvModal.hide('new-payout');
          this.member = "";
          this.amount = "";
          this.reference = "";
          this.$toast.success("New Member Payout Added");
          this.saveBtn = false;
          this.saveError = "";
        }
      });
    },
    edit(id, member, amount, mode_of_payment, reference, date_of_payment) {
      this.id = id;
      this.member = member;
      this.amount = amount;
      this.mode_of_payment = mode_of_payment;
      this.reference = reference;
      this.date_of_payment = date_of_payment;
      this.$bvModal.show('edit-payout')
    },
    approve(id, member, amount, mode_of_payment, reference, date_of_payment) {
      this.id = id;
      this.member = member.member_id;
      this.membername = member.name;
      this.amount = amount;
      this.mode_of_payment = mode_of_payment.name;
      this.reference = reference;
      this.date_of_payment = date_of_payment;
      this.$bvModal.show('approve-payout')
    },
    remove(id, member) {
      this.id = id;
      this.membername = member;
      this.$bvModal.show('delete-payout')
    },

    async editPayout() {
      let formData = new FormData();
      formData.append("id", this.id);
      formData.append("member", this.member);
      formData.append("amount", this.amount);
      formData.append("mode_of_payment", this.mode_of_payment);
      formData.append("reference", this.reference);
      formData.append("date_of_payment", this.date_of_payment);
      let url = "/updateinterestpayout";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchInterestPayouts();
          this.$bvModal.hide('edit-payout');
          this.member = "";
          this.amount = "";
          this.reference = "";
        }
      });
    },
    async approvePayout() {
      let formData = new FormData();
      formData.append("id", this.id);
      let url = "/approveinterestpayout";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchInterestPayouts();
          this.$bvModal.hide('approve-payout');
        }
      });
    },
    async removePayout() {
      let formData = new FormData();
      formData.append("id", this.id);
      let url = "/removeinterestpayout";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchInterestPayouts();
          this.$bvModal.hide('delete-payout');
        }
      });
    },
    FilterData() {
      this.filterInterestPayouts({ datefrom: this.date_from, dateto: this.date_to });
    },
  },
};
</script>